import authorizedApi from '@store/services/authorizedApi';
import { createParamsString } from '@utils/helpers';

import {
  IAssetsReportRequest,
  ILayersReportRequest,
  INodesReportRequest,
} from './types';

const reportsApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    generateLayersReport: builder.mutation<string, ILayersReportRequest>({
      query: ({ projectId, ...params }) => ({
        url: `projects/${projectId}/export/?${createParamsString(params)}`,
        method: 'GET',
        responseHandler: (response: Response) => response.arrayBuffer(),
      }),
    }),

    generateNodesReport: builder.mutation<string, INodesReportRequest>({
      query: ({ projectId, ids, layers }) => ({
        url: `projects/${projectId}/export/`,
        method: 'POST',
        body: { id: ids, ...(layers?.length ? { layers } : {}) },
        responseHandler: (response: Response) => response.arrayBuffer(),
      }),
    }),

    generateAssetsReport: builder.mutation<string, IAssetsReportRequest>({
      query: ({ projectId, ...params }) => ({
        url: `projects/${projectId}/export/asset/`,
        params,
        method: 'GET',
        responseHandler: (response: Response) => response.arrayBuffer(),
      }),
    }),

    generateRegisterReport: builder.mutation<string, string>({
      query: (projectId) => ({
        url: `projects/${projectId}/export/risk-register/`,
        method: 'GET',
        responseHandler: (response: Response) => response.arrayBuffer(),
      }),
    }),
  }),
});

export const {
  useGenerateLayersReportMutation,
  useGenerateNodesReportMutation,
  useGenerateAssetsReportMutation,
  useGenerateRegisterReportMutation,
} = reportsApi;
